import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import "./assets/less/Univ.less"
import BaiduMap from "vue-baidu-map"
import VueCookies from "vue-cookies"
import axios from "axios"
Vue.prototype.$http = axios

Vue.use(VueCookies)
Vue.use(BaiduMap, {
  ak: "WDiUTNEy8QThHEth9tzM42KmLE4758ME",
})

Vue.$cookies.config("30d")
window.$cookies.config("30d")

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

// 百度统计
// router.afterEach(( to, from, next ) => {
//   setTimeout(()=>{
//         var _hmt = _hmt || [];
//         (function() {
//           var hm = document.createElement("script");
//           hm.src = "https://hm.baidu.com/hm.js?c1c8046f22e9d8ebafb9090a65fde577";
//           var s = document.getElementsByTagName("script")[0];
//           s.parentNode.insertBefore(hm, s);
//         })();
//   },0);
// });

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app")
